import * as React from 'react';
import {useState} from 'react';

import Progress from '../ProgessBar/ProgessBar';
import FerrariTestCard from '../TestCard';

import Digital from '../FerrariIcon/Digital';
import Awareness from '../FerrariIcon/Awareness';
import DigitalProgress from '../FerrariIcon/DigitalProgress';
import Knowledge from '../FerrariIcon/Knowledge';
import Personal from '../FerrariIcon/Personal';

import cl from 'classnames';

import s from './SectionsPage.module.css';

export default function SectionsPage(props) {
  const {
    testsCompleted,
    testsTotal,
    sections,
    percent,
    currentSection,
    animationState,
    order,
    lang,
  } = props;

  const sectionDescription = sections[currentSection].description;

  return (
    <div>
      <div id="ferrari-progress-bar" className={cl(s.Progressbar)}>
        <Progress
          testsCompleted={testsCompleted}
          testsTotal={testsTotal}
          sections={sections}
          order={order}
          percent={percent}
          current={currentSection}
        />
      </div>
      <div
        id="ferrari-section"
        className={cl(s.InformationGroup, animationState === 'entering' ? s.Entering : '')}
      >
        <div
          id="ferrari-section-description"
          className={cl(s.SectionInformation, animationState === 'entering' ? s.Entering : '')}
        >
          <div className={s.SectionHeader}>
            {currentSection === order.getIn([1]) ? (
              <Digital color="#fff200" />
            ) : currentSection === order.getIn([0]) ? (
              <Knowledge color="#fff200" />
            ) : currentSection === order.getIn([2]) ? (
              <Awareness color="#fff200" />
            ) : (
              <Personal color="#fff200" className={s.Personal} />
            )}

            <div className={s.SectionInfoName}> {currentSection}</div>
            <span className={s.HorizontalBar} />
            <div className={s.SectionCompletionInfo}>
              {testsCompleted} / {testsTotal}
            </div>
          </div>
          <div className={s.SectionDescription}>{sectionDescription}</div>
        </div>

        <div
          id="ferrari-section-cards"
          className={cl(s.CardSlider, animationState === 'entering' ? s.Entering : '')}
        >
          {sections[currentSection].tests.map(test => {
            return <FerrariTestCard tests={test} lang={lang} />;
          })}
        </div>
      </div>
    </div>
  );
}
